// News & Events content for Runner Trade Park Limited (sourced from rtplbd.com/news-events)

export const NEWS = [
  {
    id: "21",
    title: "শুভ নববর্ষ ১৪৩৩ — Pohela Boishakh Celebration",
    date: "2026-04-15",
    tag: "Culture",
    image: "/content/news/news-21.jpg",
    excerpt:
      "Our team came together at the office to celebrate the Bangla New Year with tradition, warmth and shared dreams for a successful year ahead.",
    body: [
      "At Runner Trade Park Ltd. we believe in loving our roots and building a vibrant workplace culture. To mark the Bangla New Year, our team gathered at the office for a joyful celebration full of the warmth of tradition.",
      "We are proud of our team's togetherness and remain committed to maintaining excellence in the year ahead.",
      "শুভ নববর্ষ ১৪৩৩ — best wishes to everyone from the Runner Trade Park family.",
    ],
  },
  {
    id: "20",
    title: "The Specialist Has Arrived! A New Era of Performance",
    date: "2026-04-06",
    tag: "Announcement",
    image: "/content/news/news-20.jpg",
    excerpt:
      "Runner Trade Park Limited is now the Exclusive Distributor of Eurogrip Tyres in Bangladesh.",
    body: [
      "Runner Trade Park Limited is proud to announce that we are now the Exclusive Distributor of Eurogrip Tyres in Bangladesh!",
      "Get the grip you deserve and the control you need. Today is the day to switch to the best.",
      "Available now through our exclusive dealer network nationwide.",
    ],
  },
  {
    id: "19",
    title: "RTPL Signs Exclusive Eurogrip Tyre Distribution Agreement",
    date: "2026-04-06",
    tag: "Partnership",
    image: "/content/news/news-19.jpg",
    excerpt:
      "A significant leap forward: RTPL officially becomes the Exclusive Distributor of the world-renowned Eurogrip in Bangladesh.",
    body: [
      "We are proud to announce a significant leap forward for Runner Trade Park Limited. We have officially signed an agreement with the world-renowned tyre brand Eurogrip, becoming their Exclusive Distributor in Bangladesh!",
      "The ceremony was graced by the presence of our esteemed leaders — Ms. Rudaba Tazin, Managing Director, Runner Trade Park Ltd., and Mr. Sahadat Hasan Shimul, Country Manager, Eurogrip.",
      "We look forward to a successful and long-lasting journey together.",
    ],
  },
  {
    id: "18",
    title: "A New Chapter Begins for Runner Trade Park",
    date: "2026-04-06",
    tag: "Milestone",
    image: "/content/news/news-18.jpg",
    excerpt:
      "Marking an exciting new milestone in our journey to serve riders and workshops across Bangladesh.",
    body: [
      "A new chapter begins for Runner Trade Park Limited as we continue expanding our product portfolio and strengthening our nationwide distribution network.",
      "Our commitment to authenticity, quality and customer-centric service remains at the heart of everything we do.",
    ],
  },
  {
    id: "17",
    title: "Eid-Al-Adha Greetings",
    date: "2025-06-04",
    tag: "Festival",
    image: "/content/news/news-17.jpg",
    excerpt: "Eid Mubarak from the Runner Trade Park family.",
    body: [
      "Wishing everyone a blessed Eid-Al-Adha filled with peace, prosperity and togetherness — from all of us at Runner Trade Park Limited.",
    ],
  },
  {
    id: "10",
    title: "আমাদের গর্ব, আমাদের অহংকার — International Mother Language Day",
    date: "2025-02-21",
    tag: "National",
    image: "/content/news/news-10.jpg",
    excerpt:
      "Honouring the language martyrs on 21st February — our pride and our heritage.",
    body: [
      "On International Mother Language Day, we pay our deepest respect to the language martyrs of 1952.",
      "আমাদের গর্ব, আমাদের অহংকার — their sacrifice remains our eternal pride.",
    ],
  },
  {
    id: "7",
    title: "Dealer Meet Programme 2025",
    date: "2025-02-13",
    tag: "Event",
    image: "/content/news/news-7.jpg",
    excerpt:
      "Bringing our valued dealer partners together to celebrate shared success and plan for the year ahead.",
    body: [
      "Runner Trade Park Ltd. hosted its Dealer Meet Programme 2025, bringing together our valued dealer partners from across the country.",
      "The event celebrated our shared achievements and reinforced our commitment to growing together in the year ahead.",
    ],
  },
  {
    id: "6",
    title: "Eid Al Adha Greetings",
    date: "2024-06-16",
    tag: "Festival",
    image: "/content/news/news-6.jpg",
    excerpt: "Eid Mubarak to all from Runner Trade Park Limited.",
    body: [
      "May this Eid-Al-Adha bring joy, peace and prosperity to you and your loved ones. Eid Mubarak from Runner Trade Park Limited.",
    ],
  },
  {
    id: "5",
    title: "International Labour Day",
    date: "2024-04-30",
    tag: "National",
    image: "/content/news/news-5.jpg",
    excerpt: "Saluting the spirit and dedication of workers everywhere.",
    body: [
      "On International Labour Day, we honour the hard work and dedication of workers everywhere — the driving force behind every achievement.",
    ],
  },
];

export const formatNewsDate = (iso) =>
  new Date(iso).toLocaleDateString("en-US", { year: "numeric", month: "short", day: "numeric" });
